
import { TYPE_BUTTONS } from '../../../../../constans';
import Row from '../../../Blocks/Row';
import H2 from '../../../WrapsStyle/H/H2';
import Button from '../../Button';

import Dropzone from 'react-dropzone-uploader';
import PopUp from '../../../Blocks/PopUp';

const PopUpDropzone = ({ close = () => { }, onClickLoad = () => { } }) => {

  const handleSubmit = (files, allFiles) => {
    let filesBinary = files.map((f) => f.file);
    onClickLoad(filesBinary);
    allFiles.forEach((f) => f.remove());
  }

  return (
    <PopUp close={close} clickOutside={false} style={{ minWidth: '500px' }}>
      <H2 style={{ marginBottom: '15px' }}>Загрузка изоборажене</H2>

      <Dropzone
        inputContent="Выберите фото"
        // onChangeStatus={handleChangeStatus}
        onSubmit={handleSubmit}
        accept="image/*"
        maxFiles={10}
        submitButtonContent={'Загрузить'}
      />
      <Row style={{ marginTop: '30px' }}>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default PopUpDropzone;
